import loggingApi from '@sleepstation/logger'
import {
  curry,
  equals,
  find,
  init,
  last,
  nth,
  pipe,
  prop,
  propEq,
  split,
  tail,
  when,
} from 'ramda'
import urlParse from 'url-parse'
import LOG_GROUP from '../const/logGroup'
import CONTENT from '../data/content'
import { getPortal } from './relations/portal'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const logger = loggingApi.getLogger({
  group: LOG_GROUP.ROUTER,
})

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const after = curry((match, s) => pipe(split(match), nth(1))(s))

const getLastCharIsSlash = pipe(last, equals(`/`))

const stripTrailingSlash = when(getLastCharIsSlash, init)

const getPortalRelativeRoute = (portalNamespace, url) =>
  pipe(
    urlParse,
    prop(`pathname`),
    tail,
    after(portalNamespace),
    stripTrailingSlash
  )(url)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const findTemplateByRoute = (route) =>
  find(propEq(route, `route`), CONTENT.template)

export const findTemplateByName = (name) =>
  find(propEq(name, `name`), CONTENT.template)

export const getPageDataFromTemplateByUrl = (portalNamespace, url, portal) => {
  const route = getPortalRelativeRoute(portalNamespace, url)
  const template = findTemplateByRoute(route)
  if (!template) {
    logger.error(`No template for route: '${route}'`)
  }
  return template.getPageData({ portal })
}

export const getPageData = (name, params) => {
  const template = findTemplateByName(name)
  const page = template.getPageData(params)
  return {
    page,
  }
}

export const getPageDataForRequest = ({
  params: { portalNamespace },
  request: { url },
}) => {
  try {
    const portal = getPortal({ portalNamespace })

    // Handle cases where the portalNamespace doesn't match one of our portals
    if (!portal) {
      throw new Response(`Not Found`, { status: 404 })
    }

    const page = getPageDataFromTemplateByUrl(portalNamespace, url, portal)

    const data = {
      page,
      portal,
    }

    logger.info(`Got page data for route '${url}'`, data)

    return data
  } catch (error) {
    logger.error(`There was a problem getting page data for route: '${url}'`, {
      originalError: error,
    })
    throw error
  }
}
